import axios from 'axios';
import * as types from '../constants/ActionTypes';
import * as notifier from '../constants/NotifierTypes';
import { locationUpdate } from './action-contact-location';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export const preserveFieldDataNoIntent = formData => ({
  type: types.PRESERVE_FIELD_DATA_NO_INTENT,
  payload: formData,
});

export const sendEmailRequestNoIntent = () => ({
  type: types.SEND_EMAIL_NO_INTENT,
});

export const receiveEmailSuccessResponseNoIntent = options => ({
  type: types.RECEIVE_EMAIL_RESPONSE_NO_INTENT,
  payload: notifier.getEmailSentSuccess(options),
});

export const receiveEmailErrorResponseNoIntent = () => ({
  type: types.RECEIVE_EMAIL_ERROR_NO_INTENT,
  payload: notifier.functionIsUnavailable,
});

export const goBackToChangeTopicTreeNoIntent = () => ({
  type: types.CANCEL_EMAIL_FORM_NO_INTENT,
});

export const goBackToCancelEmailFormNoIntent = () => ({
  type: types.CANCEL_EMAIL_FORM_NO_INTENT,
});

export const preserveDataNoIntent = responseData => (dispatch) => {
  dispatch(preserveFieldDataNoIntent(responseData));
};

export const sendEmailNoIntent = options => (dispatch) => {
  dispatch(sendEmailRequestNoIntent());
  axios.post('/smarthelp/create-msg', options.emailPayload).then(() => {
    dispatch(receiveEmailSuccessResponseNoIntent({ hasCommunityAccess: options.hasCommunityAccess, isSmcEnabled: options.isSmcEnabled, desc: options.thankyouPageDescription }));
  }).catch(() => {
    dispatch(receiveEmailErrorResponseNoIntent());
  });
};

export const cancelEmailFormNoIntent = () => (dispatch) => {
  dispatch(goBackToCancelEmailFormNoIntent());
  dispatch(locationUpdate({ pageName: 'contactUs' }));
};
